import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormControl, UntypedFormBuilder, Validators, } from "@angular/forms";

import { EmpresasSucursalModel } from "src/app/models/empresasSucursal.model";
import { TreeNode } from "src/app/interfaces/common.interface";
import { LocalStorageService } from "angular-web-storage";

@Component({
  selector: "app-selector-empresa",
  templateUrl: "./selector-empresa.component.html",
  styleUrls: ["./selector-empresa.component.scss"],
})
export class SelectorEmpresaComponent implements OnInit, OnChanges {
  @Input() empresas: EmpresasSucursalModel[] = [];
  @Input() seleccionSucursal: boolean = false;
  @Output() seleccionEmpresas = new EventEmitter<number[]>();
  nodes: TreeNode[] = [];
  empresaSucursalSeleccionadas: FormControl;
  empresaSeleccionada:string = '';

  sucursales: any[] = [];

  constructor(private fb: UntypedFormBuilder, private localStorageService: LocalStorageService) {
    this.empresaSucursalSeleccionadas = this.fb.control([], [Validators.required]);
  }

  get empresasSeleccionadas(){
    const sucursalEmpresa:number[] = [];
    for(const empresa of this.empresaSucursalSeleccionadas.value){
      const [empresaCodigo, sucursalCodigo] = empresa.value.toString().split(',');
      sucursalEmpresa.push(parseInt( sucursalCodigo ? sucursalCodigo : empresaCodigo));
      if(empresa.items && empresa.items.length > 0){
        for(const sucursal of empresa.items){
          const [ _, sucursalCodigo] = sucursal.value.toString().split(',');
          sucursalEmpresa.push(parseInt( sucursalCodigo));
        }
      }
    }
    return [...new Set(sucursalEmpresa.filter((sucursal) => this.sucursales.find((permiso) => permiso.sucursalCodigo == sucursal)))].sort((a,b) => a - b);
  }

  get sucursalSeleccionada(){
    const sucursal = this.empresaSucursalSeleccionadas.value[0];
    const empresa = this.empresas.find((empresa) => empresa.codigoEmpresa == sucursal.value.toString().split(',')[0]);
    return empresa.codigoSucursal == empresa.codigoEmpresa ? empresa.razonSocial : `${empresa.razonSocial} / ${sucursal.text}`;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.empresas) {
      this.makeNodes();
    }
  }
  ngOnInit(): void {
    this.makeNodes();

    this.sucursales = (this.localStorageService.get('permisos') || []).map((permiso) => permiso.data);
    this.empresaSucursalSeleccionadas.valueChanges.subscribe((value: TreeNode[]) => {
      console.log('Empresa', value);
      const sucursalEmpresa:number[] = [];
      for(const empresa of value){
        const [empresaCodigo, sucursalCodigo] = empresa.value.toString().split(',');
        sucursalEmpresa.push(parseInt( sucursalCodigo ? sucursalCodigo : empresaCodigo));
        if(empresa.items && empresa.items.length > 0){
          for(const sucursal of empresa.items){
            const [ _, sucursalCodigo] = sucursal.value.toString().split(',');
            sucursalEmpresa.push(parseInt( sucursalCodigo));
          }
        }
      }
      this.seleccionEmpresas.emit([...new Set(sucursalEmpresa.filter((sucursal) => this.sucursales.find((permiso) => permiso.sucursalCodigo == sucursal)))].sort((a,b) => a - b));
    })
  }

  private makeNodes(){
    /* Genera el arbol ramificado */
    this.nodes = this.empresas.reduce((acc: TreeNode[], empresa) => {
      const existe = acc.find((item) => item.value === empresa.codigoEmpresa);
      if (existe) {
        existe.items.push({
          text: empresa.sucursal,
          value: empresa.codigoEmpresa + ',' + empresa.codigoSucursal,
        });
      } else {
        const node: TreeNode = {
          text: empresa.rutRazonSocial,
          value: empresa.codigoEmpresa,
          items: [],
        };
        if (empresa.codigoEmpresa !== empresa.codigoSucursal) {
          node.items.push({
            text: empresa.sucursal,
            value: empresa.codigoEmpresa + ',' + empresa.codigoSucursal,
          });
        }
        acc.push(node);
      }
      return acc;
    }, []);

    console.log('nodes', this.nodes);
  }

  public setFocus(){
    const buttonElement = document.activeElement as HTMLElement;
    buttonElement.blur();
  }

  onValueChange(selectedValues: TreeNode[]) {
    if(!this.seleccionSucursal){
      return;
    }
    const nuevaSeleccion:TreeNode[] = [];
    const empresasSeleccionadas = selectedValues.filter((node) => node.items && node.items.length > 0);
    const sucursalesSeleccionadas = selectedValues.filter((node) => !node.items || node.items.length == 0);
    //Selecciona la empresa completa
    if(empresasSeleccionadas.length > 0){
      const node = empresasSeleccionadas.pop();
      this.empresaSeleccionada = this.empresas.find((empresa) => empresa.codigoEmpresa == node.value).razonSocial;
      for(const child of node.items){
        nuevaSeleccion.push(child);
      }
    }else{
      //Selecciona una sucursal
      const node = sucursalesSeleccionadas.pop();
      const [empresaCodigo, sucursalCodigo] = node.value.toString().split(',');
      this.empresaSeleccionada = empresaCodigo == sucursalCodigo 
          ? this.empresas.find((empresa) => empresa.codigoEmpresa == empresaCodigo).razonSocial 
          : `${this.empresas.find((empresa) => empresa.codigoEmpresa == empresaCodigo).razonSocial} / ${node.text}`;
      if(sucursalCodigo){
        const existeSucursal = nuevaSeleccion.findIndex((item) => item.value.split(',')[0] == empresaCodigo);
        if(existeSucursal != -1){
          nuevaSeleccion[existeSucursal] = node;
        }else{
          nuevaSeleccion.push(node);
        }
      }else{
        //Selecciona una empresa
        this.empresaSeleccionada = this.empresas.find((empresa) => empresa.codigoEmpresa == node.value).razonSocial;
        nuevaSeleccion.push(node);
      }
    }
    this.empresaSucursalSeleccionadas.setValue(nuevaSeleccion);
  }
}
